import { API } from "@/services"

export const AUTH_ENDPOINTS = {
  login(data={}){
    return API.Axios.error_capture.v1.request({
      url: `auth/login`,
      method: 'POST',
      data,
      authentication: true,
    })
  },
  refreshToken(data={}){
    return API.Axios.error_capture.v1.request({
      url: `auth/refresh-token`,
      method: 'POST',
      data,
      authentication: true,
    })
  },
  logout(data={}){
    return API.Axios.error_capture.v1.request({
      url: `auth/logout`,
      method: 'POST',
      data,
      authentication: true,
    })
  },
}